export default __webpack_public_path__ + "static/media/blackbird.063549aa.jpg";